var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-taobaoAuth"},[_c('Navigation',{attrs:{"title":"淘宝账户授权登录","isListenClick":""},on:{"listenClick":_vm.handleClickBack}}),_c('div',{staticClass:"content-wrap"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }